import { Injectable } from '@angular/core';

import { BalancesHttpService } from '@ib-shared/services/balances-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class WithdrawFacadeService {
  constructor(private balancesHttpS: BalancesHttpService) {}
  increaseBalance(v: number): Observable<boolean> {
    return this.balancesHttpS.increaseBalance(v);
  }
}
